import { LoaderCircle, LogIn, ShieldCheck } from 'lucide-react'
import { useState, type FormEvent } from 'react'

import { useAuth } from '../lib/auth'

export function LoginGate() {
  const auth = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const submitLogin = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setIsSubmitting(true)
    setErrorMessage(null)
    try {
      await auth.signIn(email, password)
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Login failed'
      setErrorMessage(message)
    } finally {
      setIsSubmitting(false)
    }
  }

  if (auth.status === 'loading') {
    return (
      <main className="loginScreen">
        <div className="loginPanel">
          <ShieldCheck size={28} aria-hidden="true" />
          <h1>MarkLens</h1>
          <p className="loginMuted">Checking operator session</p>
        </div>
      </main>
    )
  }

  return (
    <main className="loginScreen">
      <form className="loginPanel" onSubmit={submitLogin}>
        <div className="loginBrand">
          <ShieldCheck size={28} aria-hidden="true" />
          <div>
            <h1>MarkLens</h1>
            <p>Operator access</p>
          </div>
        </div>
        <label className="fieldLabel">
          <span>Email</span>
          <input
            autoComplete="email"
            name="email"
            type="email"
            value={email}
            onChange={(event) => setEmail(event.currentTarget.value)}
            required
          />
        </label>
        <label className="fieldLabel">
          <span>Password</span>
          <input
            autoComplete="current-password"
            name="password"
            type="password"
            value={password}
            onChange={(event) => setPassword(event.currentTarget.value)}
            required
          />
        </label>
        {errorMessage ? <p className="formError">{errorMessage}</p> : null}
        <button className="primaryButton loginButton" type="submit" disabled={isSubmitting}>
          {isSubmitting ? (
            <LoaderCircle size={18} aria-hidden="true" />
          ) : (
            <LogIn size={18} aria-hidden="true" />
          )}
          <span>{isSubmitting ? 'Signing in' : 'Sign in'}</span>
        </button>
      </form>
    </main>
  )
}
